import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { ErrorsActionTypes, HandleError } from './actions';

@Injectable()
export class ErrorEffects {
  private _actions$ = inject(Actions);
  private _handler = inject(ErrorHandler);

  handleError$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType<HandleError>(ErrorsActionTypes.HandleError),
        map((action) => this._handler.handleError(action.payload.error)),
      ),
    { dispatch: false },
  );

  constructor() {}
}
